import { Component, OnInit } from '@angular/core';
import { RowEvent } from 'ag-grid-community';
import { Helper } from 'src/app/shared/classes/Helper';
import { HitApi } from 'src/app/shared/classes/HitApi';
import { ModalInjectedData } from 'src/app/shared/classes/ModalInjectedData';
import { Widget } from 'src/app/shared/classes/Widget';
import { CaChildIntegrationComponent } from 'src/app/shared/components/modal-templates/integration/ca-sdm-modal/ca-sdm-child-level-integration/ca-child-integration/ca-child-integration.component';
import { CaIntegrationStepOneComponent } from 'src/app/shared/components/modal-templates/integration/ca-sdm-modal/ca-sdm-parent-Integration-step-one/ca-integration-step-one/ca-integration-step-one.component';
import { CaIntegrationStepTwoComponent } from 'src/app/shared/components/modal-templates/integration/ca-sdm-modal/ca-sdm-parent-integration-step-two/ca-integration-step-two/ca-integration-step-two.component';
import { ButtonType } from 'src/app/shared/enums/ButtonType';
import { IconType } from 'src/app/shared/enums/IconType';
import { IntegrationName } from 'src/app/shared/enums/IntegrationName';
import { ModalType } from 'src/app/shared/enums/ModalType';
import { IModalData } from 'src/app/shared/interfaces/modal/IModalData';
import { ITableGeneratorInput } from 'src/app/shared/interfaces/table-generator/ITableGeneratorInput';
import { ButtonColorType } from './../../../../../../enums/ButtonColorType';
import { MultiButtonGeneratorComponent } from './../../../../../multi-button-generator/multi-button-generator.component';

@Component({
    selector: 'app-ca-integration-table',
    templateUrl: './ca-integration-table.component.html',
    styleUrls: ['./ca-integration-table.component.sass']
})
export class CaIntegrationTableComponent implements OnInit {
    widgetRef: Widget;
    tableGenInput: ITableGeneratorInput = null;
    tableData = [];
    response;
    constructor(private modalInputData: ModalInjectedData) {
        this.response = modalInputData.data['response'];
        if (this.response['childCredentials']) {
            this.tableData.push({
                ...this.response['childCredentials'],
                ownerDeskName:
                    this.response['ownerConfigueredFields']['ownerDeskName']
            });
        }
        if (this.response['credentials']) {
            this.tableData.push(this.response['credentials']);
        }

        this.widgetRef = modalInputData.data['widgetRef'];
    }

    ngOnInit(): void {
        this.setUpBasics();
    }
    setUpBasics() {
        this.tableGenInput = {
            listExtraction: {
                type: 'DIRECT'
            },
            noDataMessage: 'No Integrations Available',
            widgetIconData: {
                type: IconType.FONTAWSOME,
                class: 'fas fa-user-plus'
            },
            columns: [
                {
                    columnKey: 'childInfo',
                    columnName: 'Integration desk name',
                    cellRenderer: (rowData: RowEvent) => {
                        return rowData.data.ownerDeskName
                            ? rowData.data.ownerDeskName +
                                  ' (Child Integration)'
                            : rowData.data.deskName + ' (Parent Integration)';
                    }
                },

                {
                    columnKey: 'action',
                    columnName: 'Action',
                    pinned: 'right',
                    buttonGen: true,
                    componentFramework: MultiButtonGeneratorComponent,
                    valueFormatter: (rowData: RowEvent) => {
                        rowData['buttonGenInputs'] = [
                            {
                                buttonName: 'Edit',
                                buttonType: ButtonType.TEXT,
                                buttonColorType: ButtonColorType.INFO,
                                showLoader: false,
                                function: () => {
                                    const modalArgs: IModalData = {
                                        modalName: 'Edit CA-SDM',
                                        sourceId:
                                            this.widgetRef.widgetData
                                                .widgetUniqueIdentifier,
                                        modalType: ModalType.MIDDLE,
                                        modalIcon: {
                                            type: IconType.FONTAWSOME,
                                            class: 'fas fa-wrench'
                                        },
                                        modalSteps: rowData.data.deskName
                                            ? [
                                                  {
                                                      stepName: 'Credentials',
                                                      stepData: {
                                                          componentToLoad:
                                                              CaIntegrationStepOneComponent,
                                                          payload: {
                                                              data: {
                                                                  response:
                                                                      this
                                                                          .response,
                                                                  edit: true,
                                                                  widgetRef:
                                                                      this
                                                                          .widgetRef
                                                              }
                                                          }
                                                      }
                                                  },
                                                  {
                                                      stepName:
                                                          'Configure Fields',
                                                      stepData: {
                                                          componentToLoad:
                                                              CaIntegrationStepTwoComponent,
                                                          payload: {
                                                              data: {
                                                                  response:
                                                                      this
                                                                          .response,
                                                                  edit: true,
                                                                  widgetRef:
                                                                      this
                                                                          .widgetRef
                                                              }
                                                          }
                                                      }
                                                  }
                                              ]
                                            : [
                                                  {
                                                      stepName:
                                                          'Configure Fields',
                                                      stepData: {
                                                          componentToLoad:
                                                              CaChildIntegrationComponent,
                                                          payload: {
                                                              data: {
                                                                  response:
                                                                      this
                                                                          .response,
                                                                  edit: true,
                                                                  widgetRef:
                                                                      this
                                                                          .widgetRef
                                                              }
                                                          }
                                                      }
                                                  }
                                              ],
                                        modalWidthVw: 60,
                                        modalHeightVh: 60
                                    };
                                    this.widgetRef.modalService.openModal(
                                        modalArgs
                                    );
                                    this.widgetRef.modalService.closeModal(
                                        null,
                                        this.modalInputData.modalId
                                    );
                                }
                            },
                            // DELETE BUTTON
                            {
                                buttonName: 'Delete',
                                buttonType: ButtonType.TEXT,
                                buttonColorType: ButtonColorType.WARN,
                                showLoader: true,
                                function: (modalId: Symbol) => {
                                    // Delete integration

                                    const args = Helper.generateHitApiConfig(
                                        this.widgetRef.widgetData.widgetInfo
                                            .delete
                                    );
                                    args.input = {
                                        integrationType: IntegrationName.CASDM
                                    };
                                    args.input['parentIntegration'] = rowData
                                        .data.deskName
                                        ? true
                                        : false;
                                    args.input['childIntegration'] = rowData
                                        .data.userName
                                        ? true
                                        : false;
                                    args.function = (response) => {
                                        this.widgetRef.notificationsService.showSnackBar(
                                            `CA-SDM integration removed successfully`
                                        );
                                        this.widgetRef.modalService.closeModal(
                                            null,
                                            modalId
                                        );
                                        this.widgetRef.refreshWidget();
                                    };
                                    args.errorFunction = (error) => {
                                        Helper.showErrorMessage(
                                            this.widgetRef.notificationsService,
                                            error,
                                            'Error while removing CA-SDM'
                                        );
                                        this.widgetRef.modalService.closeModal(
                                            null,
                                            modalId
                                        );
                                    };
                                    new HitApi(
                                        args,
                                        this.widgetRef.httpService,
                                        this.widgetRef.ngZone
                                    ).hitApi();
                                    this.widgetRef.modalService.closeModal(
                                        null,
                                        this.modalInputData.modalId
                                    );
                                },
                                executeFunctionAfterConfirmation: {
                                    modalName: 'Remove CA-SDM Integration',
                                    modalIcon: {
                                        type: IconType.FONTAWSOME,
                                        class: 'far fa-trash-alt'
                                    },
                                    contextIcon: {
                                        extraClass: 'color-accent',
                                        type: IconType.FONTAWSOME,
                                        class: 'fas fa-exclamation-triangle'
                                    },
                                    confirmationMessage: `Are you sure you want to remove CA-SDM ?`,
                                    buttonText: 'Remove',
                                    buttonColorType: ButtonColorType.WARN,
                                    loaderOnExec: true
                                }
                            }
                        ];
                        return rowData;
                    }
                }
            ],
            afterResponse: null,
            selection: 'single'
        };
    }
}
